import { BaseEntity } from '../../../models';
import { ItemLinha } from '../../item-linha';

export class UsuarioLinha implements BaseEntity {
    readonly id: number;
    idUsuario: number;
    idItemLinha: number;
    itemLinha: ItemLinha;
}
